import './Vendor/Hover';
import { Blocker } from './Vendor/Scrolly/Scrolly';

class Menu
{

    private burger         :HTMLButtonElement|null = null;
    private dropdown       :HTMLUListElement|null = null;
    private dropdownMode   :number = 0;
    private dropdownIndex  :number = -1;
    private dropdownItems  :NodeList|null = null;
    private menu           :HTMLUListElement|null;
    private menuItems      :NodeList|null = null;
    private scrollBlocker  :Blocker;

    constructor()
    {

        // Blocker:

        this.scrollBlocker = Blocker.init();

        // Menu:

        this.menu = document.querySelector('.navigation__menu');
        if (!this.menu) {
            return;
        }

        // Dropdown:

        this.dropdown = document.querySelector('.navigation__dropdown');
        if (!this.dropdown) {
            return;
        }
        this.dropdownItems = this.dropdown.querySelectorAll(':scope > li');
        this.setDropdownMode(0);

        // Menu items (1st level):

        this.menuItems = this.menu.querySelectorAll('li');
        this.menuItems?.forEach((menuItem :Node, menuItemIndex :number) :void => {
            menuItem.addEventListener('click', (e :PointerEvent) :void => {
                e.stopPropagation();
                this.menuItems?.forEach((menuItem :Node) :void => {
                    (menuItem as HTMLElement).querySelector('a')?.classList.remove('-active');
                });
                (menuItem as HTMLElement).querySelector('a')?.classList.add('-active');
                // @ts-ignore
                const subpages :number = parseInt(this.dropdownItems[menuItemIndex].dataset.dropdownSubpages);
                if (
                    !subpages ||
                    (
                        1 === this.dropdownMode &&
                        this.dropdownIndex === menuItemIndex
                    )
                ) {
                    return;
                }
                e.preventDefault();
                this.setDropdownMode(1);
                this.dropdownItems?.forEach((dropdownItem :Node, dropdownItemIndex :number) :void => {
                    if (dropdownItemIndex === menuItemIndex) {
                        (dropdownItem as HTMLElement).classList.add('-active');
                        return;
                    }
                    (dropdownItem as HTMLElement).classList.remove('-active');
                });
                this.dropdownIndex = menuItemIndex;
            });
        });

        // Menu button (burger):

        this.burger = document.querySelector('button.navigation__button--menu');
        this.burger?.addEventListener('click', (e :PointerEvent) :void => {
            e.stopPropagation();
            if (this.dropdownMode === 2) {
                this.setDropdownMode(0);
                return;
            }
            this.setDropdownMode(2);
        });

        // Dismiss on click outside:

        window.addEventListener('click', (e :PointerEvent) :void => {
            if (!this.dropdown?.contains(e.target as Node)) {
                this.setDropdownMode(0);
                return;
            }
            setTimeout(() => {
                this.setDropdownMode(0);
            }, 1000);
        });
    }

    private setDropdownMode(mode :number) :Menu
    {
        this.dropdownMode = mode;
        if (mode) {
            this.scrollBlocker.on();
        }
        else {
            this.scrollBlocker.off();
        }
        if (this.dropdown) {
            if (0 !== mode) {
                this.dropdown.setAttribute('aria-hidden', 'false');
            }
            else {
                this.dropdown.setAttribute('aria-hidden', 'true');
            }
            this.dropdown.dataset.dropdownMode = mode.toString();
            setTimeout(() => {
                // @ts-ignore
                this.dropdown.classList.add('-visible');
            }, 10);
        }
        if (this.burger) {
            if (2 === mode) {
                this.burger.classList.add('-active');
            }
            else {
                this.burger.classList.remove('-active');
            }
        }
        return this;
    }

    static init() :Menu
    {
        return new this();
    }

}

export default Menu;